// NotificationDrawer.jsx
import { Drawer, List, message } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { decryptData, formatDateAndTime, limitWords } from "../../utils/utils";
import { useSelector } from "react-redux";

export const NotificationDrawer = ({ companyId, onClose, allNotifications, fetchNotifications, user_id }) => {

    console.log("NotificationDrawer props:", { companyId, allNotifications, user_id });
    const navigate = useNavigate();

    const companyData = allNotifications[companyId];
    const companyName = companyData?.company_name || "";
    const companyNotifications = companyData?.notifications || [];
    const emailId = useSelector((store) => store.auth.userInfo.user_email);

    const handleNotificationClick = (agreementId) => {
        localStorage.setItem("companyId", companyId);
        navigate(`/admin/company/${companyId}/contracts/${agreementId}`);
        onClose();
    };

    const handelDelete = async (e, notificationId) => {
        e.stopPropagation();
        try {

            await axiosInstance.post("delete_notifaction/", {
                user_id,
                notification_id: notificationId
            });
            message.success("Deleted successfully");
            fetchNotifications();
        } catch {
            message.error("Error deleting notification");
        }
    };
    const isTag = (val) => {
        const srt = val?.join(',');
        return srt?.includes(emailId)
    }


    const handleClearAll = async () => {
        try {
            await axiosInstance.post("delete_notifaction/", {
                user_id,
                type: "all_delete"
            });
            message.success("All notifications cleared");
            fetchNotifications();
        } catch {
            message.error("Failed to clear notifications");
        }
    };

    const extractEmailTag = (text) => {
        const emailTagRegex = /@[\w.-]+@[\w.-]+\.\w+\([^)]+\)/;
        const match = text.match(emailTagRegex);
        return match ? match[0] : '';
    };
    return (
        <Drawer
            title={`Notifications - ${companyName}`}
            placement="right"
            onClose={onClose}
            open={!!companyId}
            width={400}
            extra={
                <button
                    onClick={handleClearAll}
                    className="text-red-500 hover:text-red-700 text-sm font-medium"
                >
                    Clear All
                </button>
            }
        >
            <List
                dataSource={companyNotifications}
                renderItem={(item) => (
                    <List.Item
                        onClick={() => handleNotificationClick(item.agreement_id)}
                        className="cursor-pointer shadow-md hover:bg-gray-100 dark:hover:bg-[#211d53] px-3 py-[1px] rounded-xl transition border-[1px] border-gray-200 dark:border-gray-700 relative"
                    >
                        <div className="flex items-start justify-between gap-3 w-full px-2">
                            <div className="flex items-start gap-3 w-full ">
                                <div className="w-11 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-bold">
                                    📢
                                </div>
                                <div className="flex flex-col w-full">
                                    <div className="flex items-center gap-2">
                                        <h3 className="text-sm font-semibold text-gray-900 dark:text-white break-words">{limitWords(item.document_id)}</h3>
                                        <span className="bg-gray-200 text-gray-800 text-xs px-2 py-0.5 rounded-full w-6 h-6 flex items-center justify-center">
                                            {item.chat_count}
                                        </span>
                                    </div>
                                    <p className="text-[10px] font-medium text-gray-800 dark:text-gray-300 mb-2">
                                        Last Message:{" "}
                                        <span className="text-green-600 dark:text-green-500 text-[12px] font-bold pb-[1px] break-words">
                                            {extractEmailTag(decryptData(item.message))}
                                        </span>
                                        {decryptData(item.message).replace(extractEmailTag(decryptData(item.message)), '')}
                                    </p>

                                    <span className="text-[10px] text-gray-400">{formatDateAndTime(item.latest_timestamp)}</span>
                                </div>
                            </div>
                        </div>
                        <button onClick={(e) => { handelDelete(e, item.notification_id) }} className="text-gray-300 hover:text-red-500 text-lg absolute top-2 right-2">
                            &times;
                        </button>
                    </List.Item>
                )
                }
            />
        </Drawer >
    );
};
